<template>
  <q-page padding>
    <base-list></base-list>
  </q-page>
</template>

<script>
// import register from '../index.js'
export default {
  name: 'List'
  //   beforeCreate () {
  //     register()
  //   }
}
</script>
